const API_BASE_URL = "https://api.bsdfeedback.com:8000"

// const STAGGING_URL = "https://mybsd.shop:8000/"

const DEPLOYMENT_URL = "https://mybsd.shop/"

const PUSHER_BASE_URL = "https://mybsd.shop/"

const PUSHER_APP_KEY = "ae75f3a73201ef37c668"

const PUSHER_APP_CLUSTER = "eu"

const FRONT_BASE_URL = "https://dashboard.mybsd.shop/"

export  {API_BASE_URL , PUSHER_APP_CLUSTER, PUSHER_APP_KEY, PUSHER_BASE_URL,FRONT_BASE_URL}
